<h2 mat-dialog-title>Manage Widgets</h2>
<mat-dialog-content>
    @for (widget of availableWidgets; track widget) {
      <div>
        <mat-checkbox [checked]="widget.enabled" (change)="toggleWidgetEnabled(widget)">{{ widget.title || 'Untitled' }}</mat-checkbox>
      </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" class="modal-close" matDialogClose>Cancel</button>
  <button mat-button type="button" class="modal-close" (click)="saveTemplateSelection()">Save</button>
</mat-dialog-actions>
